var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rerender',{ref:"renderRef"},[_c('Bar',{attrs:{"chart-options":_vm.options,"chart-data":_vm.source,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"plugins":_vm.plugins,"css-classes":_vm.cssClasses,"styles":_vm.styles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }